import { IFilter, IFilterData } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import React from 'react';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { orderBy } from 'lodash';
export enum FilterNames {
    ACTIVITY_CODES = 'ACTIVITY_CODES',
    ACTIVITY_CODES_EXCLUDE = 'ACTIVITY_CODES_EXCLUDE',
    MIN_WBS_LEVEL = 'MIN_WBS_LEVEL',
    MAX_WBS_LEVEL = 'MAX_WBS_LEVEL',
    OPTIONS_STATUS = 'OPTIONS_STATUS',
    OPTIONS_TYPE = 'OPTIONS_TYPE',
    CRITICAL_PATH_USER_CARD_BOARD = 'CRITICAL_PATH_USER_CARD_BOARD',
    START_DATE = 'START_DATE',
    DURATION = 'DURATION',
    NAME_SEARCH = 'NAME_SEARCH',
    CONTRACT_DATA_STORY = 'CONTRACT_DATA_STORY',
    PROJECT_DATA_STORY = 'PROJECT_DATA_STORY',
    CREATED_MONTH_DATA_STORY = 'CREATED_MONTH_DATA_STORY',
    TEXT_AND_TAGS_DATA_STORY = 'TEXT_AND_TAGS_DATA_STORY',
    TIME_PERIOD = 'TIME_PERIOD',
    activity_type = 'activity_type',
    NUM_OF_DAYS_TO_BE_URGENT = 'NUM_OF_DAYS_TO_BE_URGENT',
    OVERRUN_RISK_SELECTED_PERIOD = 'OVERRUN_RISK_SELECTED_PERIOD',
    category = 'category', //TODO: see how to separate since this filter (also severity) is not being sent to BE
    severity = 'severity',
    FRAGNET_SEARCH = 'FRAGNET_SEARCH',
    FRAGNET_MILESTONE_ID_CARD_BOARD = 'FRAGNET_SEARCH',
    TAG_CARD_BOARD = 'TAG_CARD_BOARD',
    TAG_CARD_BOARD_EXCLUDE = 'TAG_CARD_BOARD_EXCLUDE',
    ACTIVITY_TYPE_FILTER = 'ACTIVITY_TYPE_FILTER',
    CRITICAL_PATH = 'CRITICAL_PATH',
    SUBMITTED_COMPLETION_CARD_BOARD = 'SUBMITTED_COMPLETION_CARD_BOARD',
    WBS_SEARCH = 'WBS_SEARCH',
    TAG_PORTFOLIO_BOARD = 'TAG_PORTFOLIO_BOARD',
    DELAY_DRIVER = 'DELAY_DRIVER',
    CRITICAL_PATH_CHANGED = 'CRITICAL_PATH_CHANGED',
    PRODUCTIVITY_PRE_DEFINED = 'PRODUCTIVITY_PRE_DEFINED',
    PROGRESS_SCURVE_GRAPH_TYPE = 'PROGRESS_SCURVE_GRAPH_TYPE',
    IS_PARTIAL_COMPLETION_CREDIT = 'IS_PARTIAL_COMPLETION_CREDIT',
    RESOURCE_NAME_CARD_BOARD = 'RESOURCE_NAME_CARD_BOARD',
    RESOURCE_TYPE_CARD_BOARD = 'RESOURCE_TYPE_CARD_BOARD',
    ACTIVITY_TYPE_BOARD = 'ACTIVITY_TYPE_BOARD',
    PROJECT_CARD_BOARD = 'PROJECT_CARD_BOARD',
    CONTRACT_CARD_BOARD ='CONTRACT_CARD_BOARD',
    VERSION_CARD_BOARD = 'VERSION_CARD_BOARD',
    ASSIGNEE_CARD_BOARD ='ASSIGNEE_CARD_BOARD',
    CONSTRAINT_DAY_SET = 'CONSTRAINT_DAY_SET',
    IMPORTANT_CARD_BOARD = 'IMPORTANT_CARD_BOARD',
    URGENT_TYPE_CARD_BOARD = 'URGENT_TYPE_CARD_BOARD',
    FRAGNET_MILESTONE_ID_COMPLETION_CARD_BOARD = 'FRAGNET_MILESTONE_ID_COMPLETION_CARD_BOARD',
    DOCLINK_CARD_BOARD = 'DOCLINK_CARD_BOARD',
    LAG_CARD_BOARD = 'LAG_CARD_BOARD',
    TRACKED_CARD_BOARD = 'TRACKED_CARD_BOARD',
    FRAGNET_FORWARD_SEARCH ='FRAGNET_FORWARD_SEARCH',
    TYPE_CARD_BOARD = 'TYPE_CARD_BOARD',
    CLUSTER_CARD_BOARD = 'CLUSTER_CARD_BOARD',
    DURATION_CARD_BOARD = 'DURATION_CARD_BOARD',
    TOTAL_FLOAT_CARD_BOARD ='TOTAL_FLOAT_CARD_BOARD',
    END_DATE_CARD_BOARD = 'END_DATE_CARD_BOARD',
    START_DATE_CARD_BOARD = 'START_DATE_CARD_BOARD',
    BASELINE_END_DATE_CARD_BOARD = 'BASELINE_END_DATE_CARD_BOARD',
    BASELINE_START_DATE_CARD_BOARD = 'BASELINE_START_DATE_CARD_BOARD',
    COMMENT_CARD_BOARD = 'COMMENT_CARD_BOARD',
    COMMENTER_CARD_BOARD = 'COMMENTER_CARD_BOARD',
    MENTIONED_USER_CARD_BOARD = 'MENTIONED_USER_CARD_BOARD',
    ACTIVITY_NAME_CARD_BOARD = 'ACTIVITY_NAME_CARD_BOARD',
    UPDATED_USER_CARD_BOARD = 'UPDATED_USER_CARD_BOARD',
    WBS_LEVEL_CARD_BOARD = 'WBS_LEVEL_CARD_BOARD',
    DELAY_DRIVER_CARD_BOARD = 'DELAY_DRIVER_CARD_BOARD',
    IMPORTANT_PREDECESSOR_OVERDUE = 'IMPORTANT_PREDECESSOR_OVERDUE',
    RCF_RISK = 'RCF_RISK',
    LONG_DURATION = 'LONG_DURATION',
    IMPORTANT_LAG_CARD_30_BOARD = 'IMPORTANT_LAG_CARD_30_BOARD',
    OVERDUE_CARD_BOARD = 'OVERDUE_CARD_BOARD',
    FINISH_PROG_OVERDUE_CARD_BOARD = 'FINISH_PROG_OVERDUE_CARD_BOARD',
    START_PROG_OVERDUE_CARD_BOARD = 'START_PROG_OVERDUE_CARD_BOARD',
    SET_BACK = 'SET_BACK',
    IMPORTANT_STALLED = 'IMPORTANT_STALLED',
    TEXT_SEARCH_CARD_BOARD = 'TEXT_SEARCH_CARD_BOARD',
    STATUS_CARD_BOARD = 'STATUS_CARD_BOARD',
}

export enum GlobalFilterFieldKey {
    cardActivity = 'cardActivity',
    assignee = 'assignee',
    status = 'status',
    milestoneFragnet = 'milestoneFragnet',
    tags = 'tags',
    activityCodes = 'activityCodes',
    wbs = 'wbs',
    important = 'important',
    urgent = 'urgent',
    completionPlanSegment = 'completionPlanSegment',
    hasAttachments = 'hasAttachments',
    lagLead = 'lagLead',
    trackedActivity = 'trackedActivity',
    activityForwardFragnet = 'activityForwardFragnet',
    cardType = 'cardType',
    finishDate = 'finishDate',
    cluster = 'cluster',
    duration = 'duration',
    float = 'float',
    startDate = 'startDate',
    baselineStartDate = 'baselineStartDate',
    baselineFinishDate = 'baselineFinishDate',
    hasComments = 'hasComments',
    relatedActivity = 'relatedActivity',
    resourceName = 'resourceName',
    resourceType = 'resourceType',
    submittedCompletion = 'submittedCompletion',
    updatedBy = 'updatedBy',
    wbsLevel = 'wbsLevel',
    riskIndicators = 'riskIndicators',
    searchByName = 'searchByName',
    progressMeasurement = 'progressMeasurement',
    resource = 'resource',
    dateRangeFilter = 'dateRangeFilter',
    productivityPreDefined = 'productivityPreDefined',
    activityType = 'activityType',
    programTags = 'programTags',
    quickAnswerFilter = 'quickAnswerFilter',
}

// TODO: consider refactor to a better data structure like this:
// const filters = {
//     DELAY_DRIVER: {
//         field: 'DELAY_DRIVER',
//         label: 'Delay Driver',
//     },
//     DELAY_DRIVER_CARD_BOARD: {
//         field: 'DELAY_DRIVER_CARD_BOARD',
//         label: 'Delay Driver',
//     },
// };

export enum FilterLabels {
    ACTIVITY_CODES = 'Activity Codes',
    ACTIVITY_CODE_CARD_BOARD = 'Activity Codes',
    ACTIVITY_CODES_EXCLUDE = 'Exclude Activity Codes',
    MIN_WBS_LEVEL = 'Min WBS Level',
    MAX_WBS_LEVEL = 'Max  WBS Level',
    OPTIONS_STATUS = 'Status',
    OPTIONS_TYPE = 'More Filters',
    dateFilter = 'Start Date',
    START_DATE = 'Start Date',
    FINISH_DATE = 'Finish Date',
    DURATION = 'Duration',
    NAME_SEARCH = 'Search Name',
    ACTIVITY_TYPE = 'Activity Type',
    cardActivity = 'Activity Type',
    activity_type = 'Activity Type',
    TIME_PERIOD = 'Time Period',
    NUM_OF_DAYS_TO_BE_URGENT = 'Urgent (Finish by)',
    OVERRUN_RISK_SELECTED_PERIOD = 'Next',
    category = 'Category',
    severity = 'Severity',
    TYPE_CARD_BOARD = 'Card Type',
    ACTIVITY_TYPE_BOARD = 'Activity Type',
    ASSIGNEE_CARD_BOARD = 'Assignee',
    UPDATED_USER_CARD_BOARD = 'Updated By',
    START_DATE_CARD_BOARD = 'Start Date',
    END_DATE_CARD_BOARD = 'End Date',
    BASELINE_START_DATE_CARD_BOARD = 'Baseline Start Date',
    BASELINE_END_DATE_CARD_BOARD = 'Baseline Finish Date',
    TAG_CARD_BOARD = 'Tags',
    TAG_CARD_BOARD_EXCLUDE = 'Exclude Tags',
    WBS_NAME_CARD_BOARD = 'WBS Name',
    ACTIVITY_NAME_CARD_BOARD = 'Activity Name',
    TEXT_SEARCH_CARD_BOARD = 'Card Search',
    DANGLING_CARD_BOARD = 'Dangling',
    CRITICAL_PATH_USER_CARD_BOARD = 'Critical Path',
    TRACKED_CARD_BOARD = 'Tracked Activity',
    COMMENT_CARD_BOARD = 'Has Comments',
    DOCLINK_CARD_BOARD = 'Has Attachments',
    IMPORTANT_CARD_BOARD = 'Important',
    WBS_LEVEL_CARD_BOARD = 'WBS Level',
    DURATION_CARD_BOARD = 'Duration',
    LAG_CARD_BOARD = 'Lag/Lead',
    TOTAL_FLOAT_CARD_BOARD = 'Float',
    DELAY_DRIVER_CARD_BOARD = 'Delay Driver',
    IMPORTANT_PREDECESSOR_OVERDUE = 'Delayed predecessor',
    RCF_RISK = 'Forecasted Duration Risk',
    CONSTRAINT_DAY_SET = 'Hard Constraints',
    LONG_DURATION = 'Long Duration',
    IMPORTANT_LAG_CARD_30_BOARD = 'Long lag/lead',
    OVERDUE_CARD_BOARD = 'Overdue Progress',
    FINISH_PROG_OVERDUE_CARD_BOARD = 'Overdue Finish Date',
    START_PROG_OVERDUE_CARD_BOARD = 'Overdue Start Date',
    SET_BACK = 'Setback',
    IMPORTANT_STALLED = 'Stalled Activities',
    URGENT_TYPE_CARD_BOARD = 'Urgent',
    FRAGNET_SEARCH = 'Activity Fragnet',
    WBS_SEARCH = 'WBS',
    RISK_INDICATORS = 'Risk Indicators',
    FRAGNET_MILESTONE_ID_CARD_BOARD = 'Activity Fragnet',
    SUBMITTED_COMPLETION_CARD_BOARD = 'Submitted Completion',
    submittedCompletionFilter= 'Submitted Completion',
    FRAGNET_MILESTONE_ID_COMPLETION_CARD_BOARD = 'Completion Plan Segment',
    ACTIVITY_TYPE_FILTER = 'Activity Type',
    activityTypeFilter='Activity Type',
    STATUS_CARD_BOARD = 'Status',
    RESOURCE_TYPE_CARD_BOARD = 'Resource type',
    RESOURCE_NAME_CARD_BOARD = 'Resource Name',
    CRITICAL_PATH = 'Critical Path',
    criticalPath = 'Critical Path',
    TAG_PORTFOLIO_BOARD = 'Program Tags',
    DELAY_DRIVER = 'Delay Driver',
    CRITICAL_PATH_CHANGED = 'Critical Path Changed',
    PRODUCTIVITY_PRE_DEFINED = 'Quick Answers',
    progressMeasurement = 'Progress Measurement by',
    partialCompletionCredit = 'Partial Completion Credit',
    milestoneFragnet = 'Activity Fragnet',
    tags = 'Tags',
    tagsExclude = 'Exclude Tags',
    activityCodes = 'Activity Codes',
    activityCodesExclude = 'Exclude Activity Codes',
    wbs = 'WBS',
    resourceType = 'Resource Type',
    resource = 'Resource Name',
    delayTypeStatus = 'Delay Type',
    statusFilter = 'Status',
    isCriticalPath = 'Critical Path Only',
    numOfMonths = 'Next',
    status = 'Status',
    show = 'Show',
    parameters = 'Parameters',
    numOfDaysToBeUrgent = 'Urgent (Finish by)',
    resolution = 'Resolution',
    dateRange = 'Date Range',
    minWbsLevel = 'Min WBS Level',
    maxWbsLevel = 'Max  WBS Level',
    isDelayDriver = 'Delay Driver',
    typeFilter = 'More Filters',
    onSearch = 'Search Name',
    name = 'Name',
    cluster='Cluster',
    CLUSTER_CARD_BOARD='Cluster',
    productivityPreDefined = 'Quick Answers',
    activityType = 'Activity Type',
    dateRangeFilter = 'Date Range',
    aggregation = 'Aggregation',
    programTags = 'Program Tags',
    timePeriod = 'Time Period',
    quickAnswerFilter = 'Quick Answer Filter',
    assignee = 'Assignee',
    delayDriver = 'Delay Driver',
    delayedPredecessor = 'Delayed predecessor',
    forecastedDurationRisk = 'Forecasted Duration Risk',
    constraintDaySet = 'Hard Constraints',
    longDuration = 'Long Duration',
    importantLagCard = 'Long lag/lead',
    overdueCardBoard = 'Overdue Progress',
    finishProgOverdue = 'Overdue Finish Date',
    startProgOverdue = 'Overdue Start Date',
    setBack = 'Setback',
    importantStalled = 'Stalled Activities',
    anyIndicator = 'Any Risk',
    important = 'Important',
    urgent = 'Urgent',
    cardSearch = 'Card Search',
    finishDate = 'End Date',
    activityForwardFragnet = 'Activity Forward Fragnet',
    cardType = 'Card Type',
    completionPlanSegment = 'Completion Plan Segment',
    duration = 'Duration',
    float = 'Float',
    hasAttachments = 'Has Attachments',
    hasComments = 'Has Comments',
    commenter = 'Commenter',
    mentioned = 'Mentioned',
    lagLead = 'Lag/Lead',
    relatedActivity = 'Related Activity',
    resourceName = 'Resource Name',
    startDate = 'Start Date',
    submittedCompletion = 'Submitted Completion',
    trackedActivity = 'Tracked Activity',
    updatedBy = 'Updated By',
    wbsLevel = 'WBS Level',
    baselineStartDate = 'Baseline Start Date',
    baselineEndDate = 'Baseline Finish Date',
    baselineFinishDate = 'Baseline Finish Date',
    RELATED_ACTIVITY = 'Related Activity',
    UPDATE_BY = 'Update By ',
    riskIndicators = 'Risk Indicators',
    searchByName = 'Search by Name',
}

export enum FilterPills {
    FINISH_PROG_OVERDUE_CARD_BOARD = 'Overdue Finish Date',
    START_PROG_OVERDUE_CARD_BOARD = 'Overdue Start Date',
}

interface IObjData {
    [key: string]: string[] | number[] | undefined;
}

/**
 * transform and object to array of object with data and name that is suitable for BE filter API
 * example:
 *      const obj = {
 *         foo: 100,
 *         bar: 'barbar',
 *         titi: true,
 *         nullish: null,
 *         undi: undefined,
 *     };
 *
 *     getFiltersData(obj) = [
 *         { name: 'foo', data: [100] },
 *         { name: 'bar', data: ['barbar'] },
 *         { name: 'titi', data: [true] },
 *     ];
 */
export const getFiltersData = (objData: IObjData): IFilter[] => {
    const filters = <IFilter[]>[];
    for (const [k, value] of Object.entries<string[] | number[] | string | number | boolean | undefined>(objData)) {
        const key = k as FilterNames;
        const isObjData =
            (k ==='startDate' && value) ||
            (k === 'finishDate' && value) ||
            (k === 'baselineFinishDate' && value) ||
            (k === 'baselineStartDate' && value) ||
            (k === 'hasComments' && value) ||
            (k === 'searchByName' && value)

        if (typeof value === 'number' ||
            typeof value === 'boolean' ||
            (value && value.length > 0) ||
            isObjData
        ) {
            filters.push({ data: !Array.isArray(value) ? [value] : value, name: key });
        }
    }
    return filters;
};

export const filterMapper = (item: string): string => item.toUpperCase().replaceAll(' ', '_');

export interface IGlobalFilterData {
    [key: string]: IFilterData;
}

//TODO: add also validation for boolean and object
export const getActiveFilterCount = (
    globalFilterData: { [p: string]: string | number | string[] | number[] | null | undefined } | undefined,
    keys: string[],
) => {
    return globalFilterData
        ? keys.filter((item) => {
              const value = globalFilterData[item];
              if (typeof value === 'number') {
                  return true;
              }
              return value ? value.length > 0 : false;
          }).length
        : 0;
};

export const createInitialFiltersStatusRef = (totalFields: (React.ReactChild | React.ReactFragment | React.ReactPortal)[]) => {
    const createStateObj: FiltersStatus = {};
    totalFields.forEach((item) => {
        if (React.isValidElement(item)) {
            const key = item.props.name;
            createStateObj[key] = {
                isReady: false,
            };
        }
    });
    return createStateObj;
};

const getTagsValue = (defaultValues, queryValue, storeValue) => {
    let tagsValue = []
    if (queryValue && Array.isArray(queryValue) && queryValue.length > 0) {
        tagsValue = queryValue.map((item) => {
            return {
                ...item,
                name: item.name,
                isExclude: item.isExclude === 'true',
            };
        });
    } else if (storeValue) {
        tagsValue = storeValue;
    } else {
        tagsValue = defaultValues
    }

    return orderBy(tagsValue, (tag) => tag.name.toLowerCase());
};

const getActivityCodesValue = (defaultValues, queryValue, storeValue) => {
    if (queryValue && Array.isArray(queryValue) && queryValue.length > 0) {
        return queryValue.map((item) => {
            return {
                ...item,
                name: Number(item.name),
                isExclude: item.isExclude === 'true',
            };
        });
    } else if (storeValue) {
        return storeValue;
    } else {
        return defaultValues
    }
};

const getProgramTags = (defaultValues, queryValue, storeValue) => {
    if (queryValue && Array.isArray(queryValue) && queryValue.length > 0) {
        return queryValue;
    } else if (storeValue) {
        return storeValue;
    } else {
        return defaultValues;
    }
}

export const filterValueResolverByKey = {
    tags: (defaultValues, queryValue, storeValue) => getTagsValue(defaultValues, queryValue, storeValue),
    activityCodes: (defaultValues, queryValue, storeValue) => getActivityCodesValue(defaultValues, queryValue, storeValue),
    programTags: (defaultValues, queryValue, storeValue) => getProgramTags(defaultValues, queryValue, storeValue),
};
